__turbopack_context__.v({
  "className": "playfair_display_dfb735ff-module__FMyQHq__className",
  "variable": "playfair_display_dfb735ff-module__FMyQHq__variable",
});
